import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquarePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquarePlus"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM16 12.7502V11.2502H12.75L12.75 8.00759H11.25L11.25 11.2502H8.00736L8.00736 12.7502H11.25V15.9929H12.75V12.7502H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquarePlus;
